import { connect } from 'react-redux';
import { compose } from 'redux';
import { withMountListener, withRenderFlag } from '@beef/react';

import { Recommendations } from 'components/Recommendations';
import {
  getCrossSellData,
  getCrossSellIsFetching,
  getCrossSellPlacement,
  getCrossSellStrategyMessage,
  getCrossSellStrategyName,
} from 'store/common/recommendations/crossSell/selectors';
import { addRecommendedDeviceToBasket } from 'store/common/recommendations/actions';
import { SOURCES_NAMES } from 'store/common/basket/constants';
import { fetchRecommendedCrossSellDevices } from 'store/common/recommendations/crossSell/actions';
import { getIsDigineticaRecommendsAvailable } from 'store/common/settings/selectors';

const mapStateToProps = (state: any) => ({
  label: 'С этим товаром покупают',
  devices: getCrossSellData(state),
  isLoading: getCrossSellIsFetching(state),
  strategyName: getCrossSellStrategyName(state), // Получаем strategyName
  strategyMessage: getCrossSellStrategyMessage(state), // Получаем strategyMessage
  placement: getCrossSellPlacement(state), // Получаем placement
  shouldRender: getIsDigineticaRecommendsAvailable(state),
});

const mapDispatchToProps = (dispatch: any) => ({
  onMount: () => dispatch(fetchRecommendedCrossSellDevices()),
  onAddToBasket: (deviceId: number) =>
    dispatch(addRecommendedDeviceToBasket(deviceId, SOURCES_NAMES.PRODUCT_DETAILS_PAGE)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRenderFlag,
  withMountListener,
)(Recommendations);
